import { render } from "./EditProfileImages.vue?vue&type=template&id=c225651c&scoped=true"
import script from "./EditProfileImages.vue?vue&type=script&lang=js"
export * from "./EditProfileImages.vue?vue&type=script&lang=js"

import "./EditProfileImages.vue?vue&type=style&index=0&id=c225651c&scoped=true&lang=css"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c225651c"]])

export default __exports__